import {extractFromDateString} from "@/helper/dateService";

let helpers = {

  isIbanAusland(iban) {
    return !!(iban && iban.length > 15 && iban.slice(0, 2).toUpperCase() !== "DE");
  },

  toGermanFloatString(number) {
    try {
      if (isNaN(number)) {
        return '0,00';
      } else {
        let stringrep = (+ number).toLocaleString('de-DE');
        if (stringrep.indexOf(',') == -1) {
          stringrep = stringrep + ',00';
        } else {
          let decimalstring = stringrep.split(',')[1];
          if (decimalstring.length === 1) {
            stringrep = stringrep + '0';
          }
        }
        return stringrep;
      }
    } catch (error) {
      return '0,00';
    }
  },

  toGermanIntegerString(number) {
    return this.toGermanFloatString(number).replace(',00', '');
  },

  formatCurrency(value) {
    return (+value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', currencyDisplay: 'symbol' });
  },

  formatCurrencyInt(value) {
    return (+value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', currencyDisplay: 'symbol',
     minimumFractionDigits: 0, maximumFractionDigits: 0, });
  },

  formatCurrencyDeckung(value) {
    if(value === 0 || value === '0' || value === '0,00'){
      return 'unbegrenzt';
    } else if(value === null || value === '') {
      return '';
    }
    else{
      return this.formatCurrencyInt(value);
    }
  },

  formatKomma(value) {
      return value.replace(',', ', ');
  },

  formatCurrencySb(value) {
    //debugger;
    if(value === null || ('' + value).length === 0) return '';

    const sbValue = this.formatCurrencyInt(value);
    if(!(/^NaN/.test(sbValue))) return sbValue;

    const sbArray = value.split('/').map(a => parseInt(a) ).sort((a, b) => a - b);
    if(sbArray.length === 2){
      return 'privat ' + this.formatCurrencyInt(sbArray[0]) + ' / gew. ' + this.formatCurrencyInt(sbArray[1]);
    }
  },

  dateToTime(strDate) {
    const dateParts = extractFromDateString(strDate);
    return dateParts ? (new Date(dateParts.year, dateParts.month - 1, dateParts.day)).getTime() : null;
  },

  statusFix( strStatus, strDate) {
    try{
      if(strStatus === 'aktiv') {
        if(strDate && this.dateToTime(strDate) < (new Date()).getTime() ) {
          return 'erloschen';
        }
      }
      return strStatus;
    } catch (error) {
      return strStatus;
    }
  },

  /*checks if both parameters have a bit set to 1 at at least one arbitrary but equal position
  * => if bitValue is a power of two, checks if the bit at the position with value bitValue is set to 1 in num*/
  isBitSet(num, bitValue) {
    num = Number(num);
    bitValue = Number(bitValue);
    return !!(num & bitValue);
  }

};

const plugin = {
  install(Vue) {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
};

export default plugin;
